import BaseObject from '../../../../../../base/base_object';
import Model from './app_flayer_model';
import HybridService from '../../../../hybrid_service';


/**
 *The AppFlayer is responsible to get the serial & testdata from the hybrid
 *The class get the original marketingData and add and replace the new serial and testdata
 *with the old values
 */
class AppFlayer extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'AppFlayer';
    _model = null;


    /**
     *
     * @param params
     */
    init(params) {
        this._model = Model.create(params);
    }


    /**
     * Get the serial data from the hybrid
     *
     * @param marketingData: the original json from the site
     * @returns {Promise : marketingData merged with the hybrid response}
    */
    getSerialData(marketingData, GNWPRequestModel) {

        return new Promise((resolve, reject) => {
            HybridService.create().getSerialData().then(data => {
                marketingData = this._model.updateData(marketingData, data);
                this.logger.info([
                    'getSerialData from Hybrid:',
                    'marketingData: ' + JSON.stringify(marketingData)
                ]);

                const smartLinkData = this._model.getSmartLinkData();
                HybridService.create().setSmartLinkData(smartLinkData,this);

                resolve(marketingData);
            }).catch(() => {
                reject(marketingData);
            });
        });
    }

    getAppMareketingData(){
        return this._model.getAppMareketingData();
    }
}

export default AppFlayer;